(function () {
  const STORAGE_KEY = "wishlist_handles_v1";

  const t = {
    add: "Tilføj til ønskeliste",
    remove: "Fjern fra ønskeliste",
    emptyTitle: "Din ønskeliste er tom",
    emptyText: "Tilføj produkter ved at trykke på hjertet på produktsiden eller i produktoversigten.",
    pageTitle: "Ønskeliste",
    removeShort: "Fjern"
  };

  function readList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("wishlist:changed", { detail: { list } }));
  }

  function has(handle) {
    return readList().includes(handle);
  }

  function add(handle) {
    const list = readList();
    if (!list.includes(handle)) {
      list.unshift(handle);
      writeList(list);
    }
  }

  function remove(handle) {
    const list = readList().filter(h => h !== handle);
    writeList(list);
  }

  function toggle(handle) {
    if (!handle) return;
    has(handle) ? remove(handle) : add(handle);
  }

  function updateButton(btn) {
    const handle = btn.getAttribute("data-wishlist-handle");
    const active = !!handle && has(handle);

    btn.setAttribute("aria-pressed", active ? "true" : "false");
    btn.classList.toggle("is-active", active);

    const label = btn.querySelector("[data-wishlist-label]");
    if (label) label.textContent = active ? t.remove : t.add;
  }

  function updateAllButtons() {
    document.querySelectorAll(".wishlist-btn[data-wishlist-handle]").forEach(updateButton);
  }

  async function fetchProduct(handle) {
    // Shopify product JSON endpoint
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed product fetch");
    return await res.json();
  }

  function formatMoney(cents) {
    const value = (cents || 0) / 100;
    return new Intl.NumberFormat("da-DK", { style: "currency", currency: "DKK" }).format(value);
  }

  function productCardHTML(p) {
    const img = p.featured_image ? `<img loading="lazy" src="${p.featured_image}" alt="${escapeHtml(p.title)}">` : "";
    const price = formatMoney(p.price);
    const url = p.url || `/products/${p.handle}`;

    return `
      <div class="wishlist-card">
        <a class="wishlist-card__media" href="${url}">
          ${img}
        </a>
        <div class="wishlist-card__body">
          <a class="wishlist-card__title" href="${url}">${escapeHtml(p.title)}</a>
          <div class="wishlist-card__price">${price}</div>

          <div class="wishlist-card__actions">
            <button class="wishlist-btn small is-active"
              type="button"
              data-wishlist-handle="${escapeAttr(p.handle)}"
              aria-pressed="true"
            >
              <span class="wishlist-btn__icon" aria-hidden="true">♥</span>
              <span data-wishlist-label>${t.removeShort}</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, s => ({ "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;" }[s]));
  }
  function escapeAttr(str) {
    return String(str).replace(/"/g, "&quot;");
  }

  async function renderWishlistPage() {
    const root = document.querySelector("[data-wishlist-page]");
    if (!root) return;

    const grid = root.querySelector("[data-wishlist-grid]");
    const empty = root.querySelector("[data-wishlist-empty]");
    const countEl = root.querySelector("[data-wishlist-count]");

    const list = readList();
    if (countEl) countEl.textContent = String(list.length);

    if (!list.length) {
      if (grid) grid.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    if (!grid) return;

    grid.innerHTML = `<div class="wishlist-loading">Indlæser…</div>`;

    const cards = [];
    for (const handle of list) {
      try {
        const p = await fetchProduct(handle);
        cards.push(productCardHTML(p));
      } catch (e) {
        // If product removed/renamed, drop it
        remove(handle);
      }
    }

    grid.innerHTML = cards.join("");
    updateAllButtons();
  }

  function bindClicks() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".wishlist-btn");
      if (!btn) return;

      const handle = btn.getAttribute("data-wishlist-handle");
      if (!handle) return;

      toggle(handle);
      updateAllButtons();
      renderWishlistPage().catch(() => {});
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindClicks();
    updateAllButtons();
    renderWishlistPage().catch(() => {});
  });

  window.addEventListener("wishlist:changed", () => {
    updateAllButtons();
    renderWishlistPage().catch(() => {});
  });

  // Expose minimal API if you want to call it elsewhere
  window.Wishlist = { readList, add, remove, toggle, has };
})();
